import moment from 'moment';

/**
 * Check if a date is tomorrow
 *
 * @param  {[type]}  targetDate        Moment date object to check
 * @param  {[type]}  [today=moment()]  Moment date object for today's datetime
 * @return {Boolean}                   Is the target date tomorrow?
 */
export function isTomorrow(targetDate, today = moment()) {
    return targetDate.isSame(today.clone().add(1, 'day'), 'day');
}
